import { createRouter, createWebHashHistory } from 'vue-router'
import HomeLive from '../views/HomeLiveView.vue'
import FooterContent from '@/components/Footer.vue'
import HeaderContent from '@/components/Header.vue'
import HeaderEmptyContent from '@/components/HeaderEmpty.vue'
import StickyBottom from '@/components/StickyBottom.vue'

import MentionsLegalesView from '../views/MentionsLegalesView.vue'
import DonneesPersonnellesView from '../views/DonneesPersonnellesView.vue'
import GestionCookiesView from '../views/GestionCookiesView.vue'
import CGLView from '../views/CGL.vue'

const routes = [
  /*{
    path: '/',
    name: 'home',
    component: HomeView
  },*/
  /*{
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/AboutView.vue')
  }*/
  {
    path: '/',
    name: 'suivi-live',
    components:{
      default:HomeLive,
      footerlive:FooterContent,
      headerlive:HeaderContent,
      stickybottommobilelive:StickyBottom,
    },
    meta: {
      title: 'Grand Raid Réunion du 15 au 18 octobre 2026 - SFR Grand Raid',
      metaTags: [
        {
          name: 'description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        },
        {
          property: 'og:description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        }
      ]
    }
  }
  ,
  {
    path: '/mentions-legales',
    name: 'mentionslegales',
    components:{
        default:MentionsLegalesView,
        footerlive:FooterContent,
        headerlive:HeaderEmptyContent,
    },
    meta: {
      title: 'Grand Raid Réunion du 15 au 18 octobre 2026 - SFR Grand Raid - Mentions Légales',
      metaTags: [
        {
          name: 'description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        },
        {
          property: 'og:description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        }
      ]
    }
  },
  {
    path: '/donnees-personnelles',
    name: 'donneespersonnelles',
    components:{
      default:DonneesPersonnellesView,
      footerlive:FooterContent,
      headerlive:HeaderEmptyContent,
    },
    meta: {
      title: 'Grand Raid Réunion du 15 au 18 octobre 2026 - SFR Grand Raid - Données Personnelles',
      metaTags: [
        {
          name: 'description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        },
        {
          property: 'og:description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        }
      ]
    }
  },
  {
    path: '/gestion-cookies',
    name: 'gestioncookies',
    components:{
      default:GestionCookiesView,
      footerlive:FooterContent,
      headerlive:HeaderEmptyContent,
    },
    meta: {
      title: 'Grand Raid Réunion du 15 au 18 octobre 2026 - SFR Grand Raid - Gestion des cookies',
      metaTags: [
        {
          name: 'description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        },
        {
          property: 'og:description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        }
      ]
    }
  },
  {
    path: '/conditions-generales-de-location',
    name: 'conditionsgeneraleslocation',
    components:{
      default:CGLView,
      footerlive:FooterContent,
      headerlive:HeaderEmptyContent,
    },
    meta: {
      title: 'Grand Raid Réunion du 15 au 18 octobre 2026 - SFR Grand Raid - Conditions Générale de location',
      metaTags: [
        {
          name: 'description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        },
        {
          property: 'og:description',
          content: 'Diagonale des Fous, Trail de Bourbon, Mascareignes, relais Zembrocal Trail – Louez votre balise GPS Capturs, profitez du Suivi Facebook Messenger, retrouvez l’actualité du Grand Raid !'
        }
      ]
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});
export default router
